import { render, staticRenderFns } from "./PromoBannerList.vue?vue&type=template&id=45c3d49c&scoped=true&"
import script from "./PromoBannerList.vue?vue&type=script&lang=js&"
export * from "./PromoBannerList.vue?vue&type=script&lang=js&"
import style0 from "./PromoBannerList.vue?vue&type=style&index=0&id=45c3d49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c3d49c",
  null
  
)

export default component.exports